import {AppThunk} from '../../index';
import {PollResponsePayload} from '../../../../shared/models/api';
import {httpService} from '../../../../shared/httpWrapper';
import {getApiRoute} from '../../../../shared/pipes/getApiRoute';
import {apiUrls} from '../../../../shared/constants/urls';
import {pollsListSlice} from '../../../reducers/polls/list';

const setPollsList = pollsListSlice.actions.setPolls;

export const getPollsList = (): AppThunk => {
  return async (dispatch) => {
    const response = await httpService.get<PollResponsePayload[]>(getApiRoute(apiUrls.getPolls));
    dispatch(setPollsList(response));
  };
};
